import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, change, formValueSelector } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { onSubmit } from '../../../../../common/components/submit-button';
import OptionSelect from '../../../../../common/components/render-input/option-select';

export const formName = Routes.STEPFOUR;

const validate = values => v(values, {
    paymentFrequency: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        }
    }
});

const paymentFrequencyOptions = {
    'Weekly': {
        title: 'Weekly Payment',
        content: 'Your monthly mortgage payment is multiplied by 12 months and divided by 52 weeks of the year, resulting in 52 payments per year.',
        frequency: 52
    },
    'Bi-Weekly': {
        title: 'Bi-Weekly Payment',
        content: 'Make 26 payments a year — your monthly mortgage payment is multiplied by 12 months and divided by 26 pay periods in a year.',
        frequency: 26
    },
    'Semi-Monthly': {
        title: 'Semi-Monthly Payment',
        content: 'Make payments twice a month, for example, on the 1st and 15th of each month. Semi-monthly payments are different than bi-weekly payments because if you pay on two dates per month, you make 24 annual payments. Bi-weekly payments result in 26 annual payments.',
        frequency: 24
    },
    'Monthly': {
        title: 'Monthly Payment',
        content: 'With a monthly mortgage payment, you make 12 payments each year — the payment is withdrawn from your bank account on the same day of every month, for example, the 1st or last day of each month.',
        frequency: 12
    }
};

const defaultPaymentFrequencyIndex = 3; // Monthly

class StepFourForm extends Component {
    componentDidUpdate(){
        const {
            props: {
                changeFieldValue,
                selectedFrequency
            }
        } = this;
        changeFieldValue('paymentFrequencyNum', paymentFrequencyOptions[selectedFrequency].frequency);
    }

    render() {
        return (
            <form className={styles.form}>
                <Field
                    name='paymentFrequency'
                    label='What’s your preferred payment frequency?'
                    options={paymentFrequencyOptions}
                    component={OptionSelect}
                />
            </form>
        );
    }
}

const selector = formValueSelector(formName);

const mapStateToProps = (state) => ({
    selectedFrequency: Object.keys(paymentFrequencyOptions).find(key => key === selector(state, 'paymentFrequency'))
});

const mapDispatchToProps = (dispatch) => ({
    changeFieldValue: (field, value) => dispatch(change(formName, field, value))
});

StepFourForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    validate,
    onSubmit,
    initialValues: {
        paymentFrequency: Object.keys(paymentFrequencyOptions)[defaultPaymentFrequencyIndex],
        paymentFrequencyNum: Object.values(paymentFrequencyOptions)[defaultPaymentFrequencyIndex].frequency
    },
    redirectPath: `/loan${Routes.STEPFIVE}`
})(StepFourForm);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(StepFourForm));

